import type { Locale } from "@/lib/i18n";

const PILLARS_EN = [
  {
    title: "Journaling",
    body: "Write things down as they come and notice how your mind begins to settle.",
  },
  {
    title: "Affect Labeling",
    body: "Put a clear word to what you're feeling and let it lose some of its grip.",
  },
  {
    title: "CBT hacks",
    body: "Notice the narrative beneath the thought and let it shift, gently.",
  },
  { title: "Neuroplasticity", body: "Come back to it, day after day, and let it hold over time." },
];
const PILLARS_FR = [
  { title: "Journaling", body: "Partagez votre ressenti à l'écrit pour prendre du recul." },
  { title: "Catégorisation", body: "Posez les mots sur votre ressenti et sentez l'apaisement." },
  { title: "Astuces TCC", body: "Hackez efficacement votre cerveau quand vous en avez besoin." },
  { title: "Neuroplasticité", body: "Pratiquez chaque jour, et observez les changements." },
];

export function CorePromiseSection({ locale }: { locale: Locale }) {
  const pillars = locale === "fr" ? PILLARS_FR : PILLARS_EN;
  const promiseCopy =
    locale === "fr"
      ? {
          eyebrow: "POURQUOI ÇA RÉSONNE",
          titleA: "Un esprit ",
          titleHighlight: "serein",
          titleB: ", en 10 minutes par jour.",
          body: "Matchamind transforme des techniques éprouvées de TCC et de neurosciences en pratiques courtes et guidées, à utiliser au réveil, quand ça flanche, ou avant de relâcher la nuit.",
        }
      : {
          eyebrow: "WHY IT LANDS",
          titleA: "A ",
          titleHighlight: "steadier",
          titleB: " mind, in minutes a day.",
          body: "Matchamind turns proven techniques from CBT and neuroscience into short, guided practices you can use at the start of your day, when things feel off, or before you reset at night.",
        };

  return (
    <section className="px-4 sm:px-6 md:px-[60px] lg:px-[120px]">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-[60px]">
        <div className="flex flex-col gap-8">
          <span className="self-start rounded-full bg-highlight-100 px-3 py-1 font-sans text-[14px] font-normal uppercase tracking-[0.2em] text-highlight-700">
            {promiseCopy.eyebrow}
          </span>
          <h2 className="font-display text-[30px] font-bold leading-[1.1] text-text-primary sm:text-[38px] lg:text-[46px] lg:leading-[52px]">
            {promiseCopy.titleA}
            <span className="inline-block translate-y-1 rounded-[50px] bg-highlight-600 px-2 py-px font-display font-semibold italic text-[var(--background-main)]">
              {promiseCopy.titleHighlight}
            </span>
            {promiseCopy.titleB}
          </h2>
          <p className="max-w-prose text-[16px] leading-[24px] text-text-secondary">
            {promiseCopy.body}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 md:gap-8">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="flex flex-col items-center justify-between gap-4 rounded-[24px] bg-surface-warm px-4 pb-6 pt-4 text-center"
            >
              <h3 className="font-display text-[16px] font-semibold leading-8 text-text-primary">
                {p.title}
              </h3>
              <p className="text-[14px] leading-5 text-text-secondary">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
